var path = '/_common/directives/ifastGrid/columnDirectives/htmlIcon.tpl.html';
var html = "<i ng-show=!hidden class=\"fa {{iconClass}} {{cssClass}}\" title=\"\"></i>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./WebContent/src/_common/directives/ifastGrid/columnDirectives/htmlIcon.tpl.html
// module id = 776
// module chunks = 0 2